import EntityInputField from "vue-forms/components/EntityInputField";
import EntityFormField from "vue-forms/components/EntityFormField";
import service from "./NetworkService";

const NetworkInputField = {
  name: "network-input-field",

  mixins: [EntityInputField],

  props: {
    service: {
      default: () => service
    }
  },

  methods: {
    customLabel(item) {
      return item.companyName;
    }
  }
};

export default {
  name: "network-form-field",

  mixins: [EntityFormField],

  props: {
    component: {
      default: () => NetworkInputField
    }
  }
};
